import React from 'react';
import InDeveloping from '../../../../components/ui/InDeveloping/InDeveloping';

const Meters = () => {
  return <InDeveloping />;
};

export default Meters;
